<template>
  <div class="tab-pane-content">
    <div class="section-header">
      <div class="section-header__icon section-header__icon--primary">
        <feather-icon
          icon="UserIcon"
          size="20"
        />
      </div>
      <div>
        <h4 class="mb-0">
          Personal Information
        </h4>
        <small class="text-muted">Manage your personal details and contact information</small>
      </div>
    </div>

    <b-row class="mt-2">
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="UserIcon"
            size="14"
            class="mr-50 text-primary"
          />
          Full Name
        </label>
        <b-form-input
          v-model="form.name"
          placeholder="Enter your full name"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="MailIcon"
            size="14"
            class="mr-50 text-primary"
          />
          Email Address
        </label>
        <b-form-input
          v-model="form.email"
          type="email"
          disabled
          placeholder="Email address"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="PhoneIcon"
            size="14"
            class="mr-50 text-primary"
          />
          Phone Number
        </label>
        <b-form-input
          v-model="form.phone"
          placeholder="Enter phone number"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="MessageCircleIcon"
            size="14"
            class="mr-50 text-success"
          />
          WhatsApp
        </label>
        <b-form-input
          v-model="form.whats_app"
          placeholder="WhatsApp number"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="BriefcaseIcon"
            size="14"
            class="mr-50 text-warning"
          />
          Job Description
        </label>
        <b-form-input
          v-model="form.job_description"
          placeholder="Your job title or role"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="FlagIcon"
            size="14"
            class="mr-50 text-danger"
          />
          Nationality
        </label>
        <b-form-input
          v-model="form.nationality"
          placeholder="Your nationality"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="LinkIcon"
            size="14"
            class="mr-50 text-info"
          />
          LinkedIn
        </label>
        <b-form-input
          v-model="form.linked_in"
          placeholder="https://linkedin.com/in/username"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="CalendarIcon"
            size="14"
            class="mr-50 text-primary"
          />
          Joined Date
        </label>
        <b-form-datepicker
          v-model="form.joined_at"
          placeholder="Select join date"
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
        />
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end mt-2 pt-1 border-top">
      <b-button
        variant="primary"
        class="profile-primary-btn"
        :disabled="isSaving"
        @click="updateProfile"
      >
        <b-spinner
          v-if="isSaving"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="SaveIcon"
          size="14"
          class="mr-50"
        />
        Save Changes
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInfoTab',
  props: {
    form: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: () => false,
    },
    updateProfile: {
      type: Function,
      required: true,
    },
  },
}
</script>
<!-- eof -->
<!-- eof2 -->
